<template>
  <div class="card card-default">
    <div class="card-header">
      <BsNotification :show="selectedEquipmentCount > 0" type="info">
        <i class="fa fa-lightbulb-on mr-1"></i>
        <span
          v-html="
            __('trim_equipment.tip', {
              selected: selectedEquipmentCount,
              important: selectedImportantCount
            })
          "
        />

        <button class="ml-2 btn btn-sm btn-outline-secondary" @click="unselectAll()">
          {{ __('equipment.btns.clear_all') }}
        </button>
      </BsNotification>

      <div class="d-flex flex-row-reverse form-inline">
        <button class="btn btn-secondary" @click="toggleSelectionView()">
          <span v-if="showOnlySelected">{{ __('equipment.btns.show_all') }}</span>
          <span v-else>{{ __('equipment.btns.show_selected') }}</span>
        </button>
        <SearchBox v-model="searchText" />
      </div>
    </div>
    <div class="card-body">
      <p v-if="displayedEquipmentGroupCount === 0">
        {{ __('equipment.no_feature') }}
      </p>
      <div v-else>
        <EquipmentList :equipments="equipmentGroups" :use-trim-equipment-items="true" />
      </div>
    </div>
  </div>
</template>

<script>
import { deburr } from 'lodash'
import EquipmentList from '@components/equipment/EquipmentList.vue'
import SearchBox from '@components/commons/SearchBox.vue'
import BsNotification from '@components/commons/BsNotification.vue'

export default {
  name: 'TrimEquipmentPage',
  components: { EquipmentList, SearchBox, BsNotification },
  props: {
    trimId: {
      type: Number,
      default: 0
    },
    equipments: {
      type: Object,
      default() {
        return {}
      }
    },
    selectedEquipments: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      showOnlySelected: false,
      searchText: ''
    }
  },
  computed: {
    equipmentGroups() {
      if (this.searchText || this.showOnlySelected) {
        let filteredList = {}
        for (let [group, equipments] of Object.entries(this.$store.state.trimEquipment.list)) {
          filteredList[group] = equipments.filter(x => {
            let selected = !this.showOnlySelected || (this.showOnlySelected && x.isSelected)
            let appearInSearch =
              this.searchText.length === 0 ||
              deburr(x.name.toLowerCase()).includes(deburr(this.searchText.toLowerCase()))

            return selected && appearInSearch
          })
        }
        return filteredList
      }

      return this.$store.state.trimEquipment.list
    },
    displayedEquipmentGroupCount() {
      let count = 0
      for (let [group, equipments] of Object.entries(this.equipmentGroups)) {
        count += equipments.length
      }
      return count
    },
    selectedImportantCount() {
      return this.$store.getters['trimEquipment/selectedImportantCount']
    },
    selectedEquipmentCount() {
      return this.$store.getters['trimEquipment/selectedEquipmentCount']
    }
  },
  created() {
    let equipmentGroups = {}

    Object.keys(this.equipments).forEach(group => {
      if (!equipmentGroups[group]) {
        equipmentGroups[group] = []
      }

      const groupEquipments = this.equipments[group]
      groupEquipments.forEach(x => {
        let equipment = {
          id: x.id,
          name: x.name,
          isSelected: x.isSelected,
          isImportant: x.isImportant
        }

        this.selectedEquipments.forEach(trimEquipment => {
          if (trimEquipment.id == x.id) {
            equipment.isSelected = true
            equipment.isImportant = trimEquipment.pivot.is_important
          }
        })

        equipmentGroups[group].push(equipment)
      })
    })

    this.$store.dispatch('trimEquipment/setList', equipmentGroups)
  },
  methods: {
    save() {
      const savingProcess = document.getElementById('save-processing')
      const savingSuccess = document.getElementById('save-success')
      const savingError = document.getElementById('save-error')

      savingProcess.style.display = 'block'

      return this.$store
        .dispatch('trimEquipment/persist', this.trimId)
        .then(() => {
          savingProcess.style.display = 'none'
          savingSuccess.style.display = 'block'
        })
        .catch(error => {
          console.error(error)
          savingProcess.style.display = 'none'
          savingError.style.display = 'block'
        })
        .finally(
          setTimeout(() => {
            savingSuccess.style.display = 'none'
            savingError.style.display = 'none'
          }, 3000)
        )
    },
    toggleSelectionView() {
      this.showOnlySelected = !this.showOnlySelected
    },
    unselectAll() {
      return this.$store.dispatch('trimEquipment/unselectAll')
    }
  }
}
</script>
